<template>
    <!-- Branches.vue -->
    <div>
        <HeaderBg :title="$t('adminArticles.title')" />
        <Alert 
            v-if="alertToggle == true"
            :acceptedDelete="acceptedDeleteCourse" 
            :messege="$t('adminArticles.confirmDelete')"
        />
        <header class="admin_content_header">
            <h2></h2>
            <div class="search">
                <input type="text" :placeholder="$t('adminArticles.searchPlaceholder')">
            </div>
            <router-link to="/admin/articles/add-articles" v-if="add_articles_permission == true">  {{$t('adminArticles.addArticle')}} </router-link>
            
        </header>
        <RequestSpinner v-if="loadingRequest == true"/>
        <div class="main_table" v-if="loadingRequest == false">
            <table width="100%">
                <thead>
                    <tr>
                        <th>{{$t('adminArticles.tableTitle')}}</th>
                        <th>{{$t('adminArticles.tableMainCategory')}}</th>
                        <th>{{$t('adminArticles.tableSubCategory')}}</th>
                        <!-- <th> اضاف بواسطة</th> -->
                        <th>{{$t('adminArticles.tableNewsStatus')}}</th>
                        <th>{{$t('adminArticles.tableComments')}}</th>
                        <th> </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="article in articles" :key="article.id">
                        <td>{{article.translation[0].name}}</td>
                        <td> {{article.category.name}} </td>
                        <td>{{article.subcategory.name}}</td>
                        <!-- <td>المكتب العلمي 2023-06-24 12:26:09</td> -->
                        <td> {{article.active ? $t('adminArticles.statusActive') : $t('adminArticles.statusInactive')}} </td>
                        <td>{{$t('adminArticles.viewComments')}}</td>
                        <td>
                            <div class="options_container" v-if="edit_articles_permission == true || delete_articles_permission == true">
                                <img src="../../../assets/images/selectIcon.png" alt="">
                                <div class="hidden_options">
                                    <button v-if="edit_articles_permission == true" @click="() => editArticle(article.id)"> <img src="../../../assets/images/edit-text.png" alt=""> {{$t('adminArticles.edit')}}  </button>
                                    <button v-if="delete_articles_permission == true" @click="() => deleteData(article.id)"> <img src="../../../assets/images/delete-text.png" alt=""> {{$t('adminArticles.delete')}} </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="pagination mt-5" v-if="articles.length >= 1">
            <b-pagination-nav align="center" :link-gen="linkGen" :number-of-pages="pages" use-router v-model="currentPage"></b-pagination-nav>
        </div>
    </div>
</template>
<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import Alert from '../../global/Alert/Alert';
import Request from '../../../services/Request';
import store from "@/store/index.js";
import RequestSpinner from '../../global/loadingSpinners/RequestSpinner';
export default {
    name:'Articles',
    components: {HeaderBg, Alert, RequestSpinner},
    data(){
        return{
            loadingRequest: true,
            articles: [],
            deleteID: '',
            alertToggle: false,

            // permissions
            add_articles_permission: false,
            edit_articles_permission: false,
            delete_articles_permission: false,

             // pagination
            apiParams: '',
            currentPage: 1,
            pages: 1,
        }
    },
    beforeMount(){
        var permissions = JSON.parse(localStorage.getItem("permissions"));

        if(permissions.includes('list articles')){
            console.log('permission')
        } else {
            this.$router.push('/login')
        }

        if(permissions.includes('add articles')){
            this.add_articles_permission = true
        } 
        if(permissions.includes('update articles')) {
            this.edit_articles_permission = true
        } 
        if(permissions.includes('delete articles')) {
            this.delete_articles_permission = true
        } 
    },
    mounted(){
        // get pagination page number from url
        const params = new URLSearchParams(window.location.search);
        const page = params.get('page');
        if(page){
            this.currentPage = page
        }
        this.getArticles();
    },
    methods:{
        editArticle(id){
            this.$router.push(`/admin/articles/add-articles/${id}`)
        },
        getArticles(){
            Request.fetch('admin/article', this.apiParams , {
                limit: store.state.limit
            })
            .then((response) => {
                this.articles = response.data.data
                this.loadingRequest = false;
                this.pages = Math.ceil(response.data.total / store.state.limit) 
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/')
                    localStorage.removeItem('token')
                }
            });
        },
        deleteData(id){
            this.deleteID = id;
            this.alertToggle = true;
        },
        acceptedDeleteCourse(){
            Request.delete('admin/article',this.deleteID)
            .then( () => {
                this.getArticles();
            })
        },
        // pagination function
        linkGen(pageNum) {
            return pageNum === 1 ? '?' : `?page=${pageNum}`   
        },
    },
    watch: {
        // pagination
        currentPage: function(val) {
            if(val === 1){
                this.apiParams = '';
                this.getArticles();
            } else{
                this.apiParams = `?page=${val}`;
                this.getArticles();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.filter{
    select{
        background-color: #FFF;
        border: 0;
        width: 89px;
        text-align: center;
        font-size: 20px;
        border-radius: 10px;
        margin-bottom: 20px;
    }
}


</style>